export default "__VITE_ASSET__01428d9e__"